import { Family } from "typing";
import {
  Container,
  Box,
  TextHighlight,
  BoxTitle,
  BoxOptions,
  TitleBox,
  BoxColor,
  ColorsContainer,
  Attribute,
} from "./styles";

interface SelectorOptionsParams {
  title: string;
  data: Family[];
}

const SelectorOptions = ({ title, data }: SelectorOptionsParams) => {
  const ITEM_SELECT_CURRENT = data?.find(
    (familyItem) => familyItem.selectedValue
  );

  const hasBackgroundColor = data?.some((item) => item.category === "Cor");

  return (
    <Container hasBackgroundColor={hasBackgroundColor}>
      <BoxTitle>
        <TitleBox>
          {title}:
          <Attribute>
            {ITEM_SELECT_CURRENT?.category === "Cor"
              ? ITEM_SELECT_CURRENT?.color.name
              : ITEM_SELECT_CURRENT?.attribute}
          </Attribute>
        </TitleBox>
      </BoxTitle>
      <BoxOptions>
        {data?.map((item) => {
          return (
            <ColorsContainer
              // Depois encontrar uma solução melhor de navegar que funcione junto com o MagicZoom
              href={`/produto/${item.productCode}`}
              target="_self"
              key={item?.productCode}
            >
              {(item.category === "Cor" && (
                <BoxColor
                  className={item.selectedValue ? "active" : "disabled"}
                  backgroundColor={item.color.hexadecimal}
                >
                  <div />
                </BoxColor>
              )) || (
                <Box className={item.selectedValue ? "active" : "disabled"}>
                  <TextHighlight isSelected={item.selectedValue}>
                    {item.attribute}
                  </TextHighlight>
                </Box>
              )}
            </ColorsContainer>
          );
        })}
      </BoxOptions>
    </Container>
  );
};

export default SelectorOptions;
